import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLeftUpArrow = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9 3.25a.75.75 0 0 1 .53.22l5 5a.75.75 0 0 1-1.06 1.06L9 5.06 4.53 9.53a.75.75 0 0 1-1.06-1.06l5-5A.75.75 0 0 1 9 3.25"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9 3.25a.75.75 0 0 1 .75.75v12A3.25 3.25 0 0 0 13 19.25h7a.75.75 0 0 1 0 1.5h-7A4.75 4.75 0 0 1 8.25 16V4A.75.75 0 0 1 9 3.25"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLeftUpArrow;
